import React from "react";
import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";

const HomePage = () => {
  return (
    <div className="w-full bg-[#0f0f0f] text-[#f2f2f2]">
      <div className="max-w-[1100px] mx-auto px-5">
        {/* SECTION 1: HERO */}
        <section className="py-[120px] md:py-[140px] border-b border-[#1a1a1a]">
          <div className="mb-6">
            <span className="text-[11px] uppercase tracking-[0.12em] text-[#555555] border border-[#222222] px-3 py-1 rounded inline-block font-mono">
              BUILDER · INDIA
            </span>
          </div>

          <h1
            className="text-[48px] sm:text-[64px] font-bold text-[#f2f2f2] leading-[1.1] mb-3"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Harshit
          </h1>

          <h2
            className="text-[22px] sm:text-[28px] font-medium text-[#cccccc] mb-4"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            I build AI products. Fast.
          </h2>

          <p className="text-[#555555] text-[15px] mb-8">
            Founder of FinishAI · Building in public since 2023
          </p>

          <div className="flex flex-wrap items-center gap-6">
            <a
              href="#now-building"
              className="text-[#f2f2f2] hover:text-white font-medium text-[15px] underline underline-offset-4 decoration-[#333333] hover:decoration-white transition-colors"
            >
              See What I'm Building →
            </a>
            <Link
              to="/contact"
              className="bg-transparent border border-[#333333] text-[#f2f2f2] px-[22px] py-[10px] rounded-[6px] text-sm hover:border-[#ffffff] transition-colors"
            >
              Get In Touch
            </Link>
          </div>
        </section>

        {/* SECTION 2: NOW BUILDING */}
        <section id="now-building" className="py-[120px] border-b border-[#1a1a1a]">
          <div className="mb-2">
            <span className="text-[11px] uppercase tracking-[0.12em] text-[#555555] border border-[#222222] px-3 py-1 rounded inline-block font-mono">
              CURRENTLY
            </span>
          </div>
          <h2
            className="text-[30px] sm:text-[36px] font-bold text-[#f2f2f2] mb-[40px]"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            What I'm Building Right Now
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-[20px]">
            {/* Card 1 */}
            <div className="bg-[#161616] border border-[#222222] rounded-[8px] p-[28px] flex flex-col justify-between">
              <div>
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-2 text-[12px] text-[#999999] font-mono">
                    <span className="w-[6px] h-[6px] rounded-full bg-[#eab308] inline-block" />
                    BUILDING
                  </div>
                  <a
                    href="https://finishai.org"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#666666] hover:text-white transition-colors"
                    aria-label="FinishAI link"
                  >
                    <ExternalLink className="w-4 h-4" />
                  </a>
                </div>
                <h3
                  className="text-[20px] font-bold text-[#f2f2f2] mb-2"
                  style={{ fontFamily: "'DM Sans', sans-serif" }}
                >
                  FinishAI
                </h3>
                <p className="text-[14px] text-[#888888] leading-relaxed mb-6">
                  AI-powered customer support chatbot platform. Helps businesses automate support without losing the human feel.
                </p>
              </div>
              <div>
                <div className="flex justify-between items-center text-[11px] text-[#666666] font-mono mb-2">
                  <span>PROGRESS</span>
                  <span>85%</span>
                </div>
                <div className="h-[2px] bg-[#222222] rounded-[2px] overflow-hidden w-full">
                  <div className="h-full bg-white rounded-[2px]" style={{ width: "85%" }} />
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div className="bg-[#161616] border border-[#222222] rounded-[8px] p-[28px] flex flex-col justify-between">
              <div>
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-2 text-[12px] text-[#999999] font-mono">
                    <span className="w-[6px] h-[6px] rounded-full bg-[#eab308] inline-block" />
                    BUILDING
                  </div>
                  <a
                    href="https://curvory.store"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#666666] hover:text-white transition-colors"
                    aria-label="Curvory link"
                  >
                    <ExternalLink className="w-4 h-4" />
                  </a>
                </div>
                <h3
                  className="text-[20px] font-bold text-[#f2f2f2] mb-2"
                  style={{ fontFamily: "'DM Sans', sans-serif" }}
                >
                  Curvory
                </h3>
                <p className="text-[14px] text-[#888888] leading-relaxed mb-6">
                  PWA pose reference camera app for artists. Dark premium UI, overlay rendering, collapsible pose selection.
                </p>
              </div>
              <div>
                <div className="flex justify-between items-center text-[11px] text-[#666666] font-mono mb-2">
                  <span>PROGRESS</span>
                  <span>65%</span>
                </div>
                <div className="h-[2px] bg-[#222222] rounded-[2px] overflow-hidden w-full">
                  <div className="h-full bg-white rounded-[2px]" style={{ width: "65%" }} />
                </div>
              </div>
            </div>

            {/* Card 3 */}
            <div className="bg-[#161616] border border-[#222222] rounded-[8px] p-[28px] flex flex-col justify-between">
              <div>
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-2 text-[12px] text-[#999999] font-mono">
                    <span className="w-[6px] h-[6px] rounded-full bg-[#22c55e] inline-block" />
                    SHIPPED
                  </div>
                </div>
                <h3
                  className="text-[20px] font-bold text-[#f2f2f2] mb-2"
                  style={{ fontFamily: "'DM Sans', sans-serif" }}
                >
                  harshitpraj.online
                </h3>
                <p className="text-[14px] text-[#888888] leading-relaxed mb-6">
                  This site. A live build log, not a portfolio. Updated as I ship things.
                </p>
              </div>
              <div>
                <div className="flex justify-between items-center text-[11px] text-[#666666] font-mono mb-2">
                  <span>PROGRESS</span>
                  <span>100%</span>
                </div>
                <div className="h-[2px] bg-[#222222] rounded-[2px] overflow-hidden w-full">
                  <div className="h-full bg-white rounded-[2px]" style={{ width: "100%" }} />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 3: SHIPPED PROJECTS */}
        <section className="py-[120px] border-b border-[#1a1a1a]">
          <div className="mb-2">
            <span className="text-[11px] uppercase tracking-[0.12em] text-[#555555] border border-[#222222] px-3 py-1 rounded inline-block font-mono">
              SHIPPED
            </span>
          </div>
          <h2
            className="text-[30px] sm:text-[36px] font-bold text-[#f2f2f2] mb-[40px]"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Things I've Shipped
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[20px]">
            {/* Project 1 */}
            <div className="bg-[#161616] border border-[#222222] rounded-[8px] p-[28px] flex flex-col justify-between">
              <div>
                <div className="flex items-center justify-between mb-3">
                  <h3
                    className="text-[18px] font-bold text-[#f2f2f2]"
                    style={{ fontFamily: "'DM Sans', sans-serif" }}
                  >
                    RingTrack
                  </h3>
                  <span className="text-[11px] text-[#22c55e] font-mono flex items-center gap-1.5">
                    <span className="w-[6px] h-[6px] rounded-full bg-[#22c55e] inline-block" />
                    Shipped
                  </span>
                </div>
                <div className="flex flex-wrap gap-1.5 mb-4">
                  <span className="bg-[#1e1e1e] text-[#888888] text-[11px] px-[10px] py-[4px] rounded-[4px] font-mono">
                    PWA · SVG · Habit Tracker
                  </span>
                </div>
                <p className="text-[14px] text-[#888888] leading-relaxed">
                  Radial habit tracker with SVG circular grid, Framer Motion animations, and localStorage. Built in one session.
                </p>
              </div>
            </div>

            {/* Project 2 */}
            <div className="bg-[#161616] border border-[#222222] rounded-[8px] p-[28px] flex flex-col justify-between">
              <div>
                <div className="flex items-center justify-between mb-3">
                  <h3
                    className="text-[18px] font-bold text-[#f2f2f2]"
                    style={{ fontFamily: "'DM Sans', sans-serif" }}
                  >
                    Cursory
                  </h3>
                  <span className="text-[11px] text-[#22c55e] font-mono flex items-center gap-1.5">
                    <span className="w-[6px] h-[6px] rounded-full bg-[#22c55e] inline-block" />
                    Shipped
                  </span>
                </div>
                <div className="flex flex-wrap gap-1.5 mb-4">
                  <span className="bg-[#1e1e1e] text-[#888888] text-[11px] px-[10px] py-[4px] rounded-[4px] font-mono">
                    AI Tools · Instagram · Digital Products
                  </span>
                </div>
                <p className="text-[14px] text-[#888888] leading-relaxed">
                  Instagram-based AI tools and resources brand. Sells reel bundles and teaches AI productivity to creators.
                </p>
              </div>
            </div>

            {/* Project 3 */}
            <div className="bg-[#161616] border border-[#222222] rounded-[8px] p-[28px] flex flex-col justify-between">
              <div>
                <div className="flex items-center justify-between mb-3">
                  <h3
                    className="text-[18px] font-bold text-[#f2f2f2]"
                    style={{ fontFamily: "'DM Sans', sans-serif" }}
                  >
                    Background Remover
                  </h3>
                  <span className="text-[11px] text-[#22c55e] font-mono flex items-center gap-1.5">
                    <span className="w-[6px] h-[6px] rounded-full bg-[#22c55e] inline-block" />
                    Shipped
                  </span>
                </div>
                <div className="flex flex-wrap gap-1.5 mb-4">
                  <span className="bg-[#1e1e1e] text-[#888888] text-[11px] px-[10px] py-[4px] rounded-[4px] font-mono">
                    Browser · Client-side · No API
                  </span>
                </div>
                <p className="text-[14px] text-[#888888] leading-relaxed">
                  Fully client-side background remover. No uploads, no API keys, runs entirely in the browser.
                </p>
              </div>
            </div>

            {/* Project 4 */}
            <div className="bg-[#161616] border border-[#222222] rounded-[8px] p-[28px] flex flex-col justify-between">
              <div>
                <div className="flex items-center justify-between mb-3">
                  <h3
                    className="text-[18px] font-bold text-[#f2f2f2]"
                    style={{ fontFamily: "'DM Sans', sans-serif" }}
                  >
                    AI Ingredient Checker
                  </h3>
                  <span className="text-[11px] text-[#22c55e] font-mono flex items-center gap-1.5">
                    <span className="w-[6px] h-[6px] rounded-full bg-[#22c55e] inline-block" />
                    Shipped
                  </span>
                </div>
                <div className="flex flex-wrap gap-1.5 mb-4">
                  <span className="bg-[#1e1e1e] text-[#888888] text-[11px] px-[10px] py-[4px] rounded-[4px] font-mono">
                    Groq API · Health · Single-file
                  </span>
                </div>
                <p className="text-[14px] text-[#888888] leading-relaxed">
                  Food and cosmetic ingredient safety checker powered by Groq. Single HTML file, no backend.
                </p>
              </div>
            </div>

            {/* Project 5 */}
            <div className="bg-[#161616] border border-[#222222] rounded-[8px] p-[28px] flex flex-col justify-between">
              <div>
                <div className="flex items-center justify-between mb-3">
                  <h3
                    className="text-[18px] font-bold text-[#f2f2f2]"
                    style={{ fontFamily: "'DM Sans', sans-serif" }}
                  >
                    Nutrition Coach
                  </h3>
                  <span className="text-[11px] text-[#22c55e] font-mono flex items-center gap-1.5">
                    <span className="w-[6px] h-[6px] rounded-full bg-[#22c55e] inline-block" />
                    Shipped
                  </span>
                </div>
                <div className="flex flex-wrap gap-1.5 mb-4">
                  <span className="bg-[#1e1e1e] text-[#888888] text-[11px] px-[10px] py-[4px] rounded-[4px] font-mono">
                    Groq API · PWA · AI
                  </span>
                </div>
                <p className="text-[14px] text-[#888888] leading-relaxed">
                  Personalized minerals and nutrition coach. Animated onboarding, radial mineral dashboard, localStorage.
                </p>
              </div>
            </div>

            {/* Project 6 */}
            <div className="bg-[#161616] border border-[#222222] rounded-[8px] p-[28px] flex flex-col justify-between">
              <div>
                <div className="flex items-center justify-between mb-3">
                  <h3
                    className="text-[18px] font-bold text-[#f2f2f2]"
                    style={{ fontFamily: "'DM Sans', sans-serif" }}
                  >
                    AI Companion Chat
                  </h3>
                  <span className="text-[11px] text-[#22c55e] font-mono flex items-center gap-1.5">
                    <span className="w-[6px] h-[6px] rounded-full bg-[#22c55e] inline-block" />
                    Shipped
                  </span>
                </div>
                <div className="flex flex-wrap gap-1.5 mb-4">
                  <span className="bg-[#1e1e1e] text-[#888888] text-[11px] px-[10px] py-[4px] rounded-[4px] font-mono">
                    Groq API · WhatsApp-style · Single-file
                  </span>
                </div>
                <p className="text-[14px] text-[#888888] leading-relaxed">
                  WhatsApp-style AI companion chat. Single HTML file using Groq API. Shipped fast.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 4: STATS */}
        <section className="py-[120px] border-b border-[#1a1a1a]">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center md:text-left">
            <div>
              <div
                className="text-[48px] font-bold text-[#f2f2f2] leading-none mb-2"
                style={{ fontFamily: "'DM Sans', sans-serif" }}
              >
                10+
              </div>
              <div className="text-[11px] uppercase tracking-[0.12em] text-[#555555] font-mono">
                PROJECTS BUILT
              </div>
            </div>

            <div>
              <div
                className="text-[48px] font-bold text-[#f2f2f2] leading-none mb-2"
                style={{ fontFamily: "'DM Sans', sans-serif" }}
              >
                2+
              </div>
              <div className="text-[11px] uppercase tracking-[0.12em] text-[#555555] font-mono">
                YEARS BUILDING
              </div>
            </div>

            <div>
              <div
                className="text-[48px] font-bold text-[#f2f2f2] leading-none mb-2"
                style={{ fontFamily: "'DM Sans', sans-serif" }}
              >
                3
              </div>
              <div className="text-[11px] uppercase tracking-[0.12em] text-[#555555] font-mono">
                LIVE PRODUCTS
              </div>
            </div>

            <div>
              <div
                className="text-[48px] font-bold text-[#f2f2f2] leading-none mb-2"
                style={{ fontFamily: "'DM Sans', sans-serif" }}
              >
                100%
              </div>
              <div className="text-[11px] uppercase tracking-[0.12em] text-[#555555] font-mono">
                SOLO SHIPPED
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 5: ABOUT STRIP */}
        <section className="py-[120px]">
          <div className="bg-[#161616] border border-[#222222] rounded-[8px] p-[40px]">
            <h3
              className="text-[28px] font-bold text-[#f2f2f2] mb-4"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
            >
              Who's Building This?
            </h3>
            <p className="text-[15px] text-[#888888] leading-relaxed mb-6 max-w-3xl">
              I'm Harshit. I build AI-powered products, tools, and SaaS from scratch — mostly solo. I ship fast, design minimal, and build things people actually use. Currently running FinishAI and always working on 2–3 projects at once.
            </p>
            <Link
              to="/about"
              className="text-[#f2f2f2] hover:text-white font-medium text-[15px] underline underline-offset-4 decoration-[#333333] hover:decoration-white transition-colors"
            >
              More about me →
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
};

export default HomePage;
